import { render, staticRenderFns } from "./AboutusPage.vue?vue&type=template&id=63c50e1f&scoped=true"
import script from "./AboutusPage.vue?vue&type=script&lang=js"
export * from "./AboutusPage.vue?vue&type=script&lang=js"
import style0 from "./AboutusPage.vue?vue&type=style&index=0&id=63c50e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c50e1f",
  null
  
)

export default component.exports